import React from 'react';
import { Settings2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function AdminButton() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <button
      onClick={() => navigate(user ? '/admin' : '/login')}
      className="fixed top-4 right-4 p-2 rounded-full bg-gray-800/50 hover:bg-gray-700/50 transition-colors duration-200 z-50"
      title="Administration"
    >
      <Settings2 className="w-5 h-5 text-gray-300" />
    </button>
  );
}